function bookings_Reducer(state = [], action) {
    switch (action.type) {
        case 'BOOKINGS/SET':
            return action.bookings;
        case 'BOOKINGS/APPEND':
            return [...(state || []), ...action.bookings];
        case 'BOOKINGS/CLEAR':
            return null;
        case 'BOOK/CLEAR':
            return null;
        default:
            return state;
    }
}

export function bookings_has_more_Reducer(state = false, action) {
    switch (action.type) {
        case 'BOOKINGS/HAS_MORE/SET':
            return action.has_more;
        case 'BOOKINGS/SET':
        case 'BOOKINGS/CLEAR':
        case 'BOOK/CLEAR':
            return false;
        default:
            return state;
    }
}

export default bookings_Reducer;
